var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popper"},[_c('xyz-transition',{attrs:{"appear":"","xyz":"fade"}},[(_vm.isOpen)?_c('div',{staticClass:"popover-content"},[_c('div',{attrs:{"x-arrow":""}}),_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }